<div class="t-popup-body" style="overflow: auto;" [formGroup]="gfs.Form"  >
    <button class="t-btn-popup-close" aria-label="close popup" (click)="close(true)"></button>
    <div class="formHeader">
        <h2 style="align-self: center;">
           Form of Consent
        </h2>
        <span *ngIf="this.gfs.Form.get('AutoIndex').value"  class="icon-print" (click)="printForm()" style="margin-inline-end: 1.5em;" aria-label="Print" matTooltip="Print"><img src="../../../assets/icons/print.svg"></span>
    </div>
 
 
    <div class="m-box" style="direction: rtl; margin: 1em 0; justify-content: space-between;">
        <section class="w100" style="direction: rtl; justify-content: space-evenly; display: flex;align-items: center;">  
            <span>  טפסים למילוי:</span>
            <span>סדציה <input type="checkbox" formControlName="SedationConsent"></span>
            <span>אנדוסקופיה <input type="checkbox" formControlName="EndoscopyConsent"></span>
        </section>
    </div>
    <div class="m-box" style="direction: rtl; margin: 1em 0; justify-content: space-between;">
        <section class="w100" style="direction: rtl; justify-content: space-evenly; display: flex;">
            <span style="margin-top: 1%;"> בדיקות לביצוע:</span>
            <span>קולונוסקופיה <input type="checkbox" formControlName="Colonoscopy"></span>
            <span>גסטרוסקופיה <input type="checkbox" formControlName="Gastroscopy"></span>
            <span>סיגמואידוסקופיה <input type="checkbox" formControlName="Sigmoidoscopy"></span>
        </section>
        <div style="display: flex; margin: 0 3.5em;">
            <div class="w40" style="display: flex; margin: 0.3em;flex-direction: row-reverse;">
                <span class="t-field t-field--number" style="direction: ltr;">
                    <input class="t-field-text" type="time" id="CheckTime" formControlName="AdmissionTime" />
                </span>
                <span style="margin-left: 0.3em; align-self: center;">
                    שעת קבלה
                </span>
            </div>
            <div class="w40" style="display: flex;margin-top: 0; margin: 0.3em;flex-direction: row-reverse;">
                <span class="t-field t-field--number" style="direction: rtl;">
                    <input class="t-field-text" type="text" formControlName="doctor" />
                </span>
                <span style="margin-left: 0.3em; align-self: center;">
                    רופא
                </span>
            </div>
        </div>
 
    </div>
    <div class="m-box" style="direction: rtl;margin: 1em 0;justify-content: space-between;" >
        <div class="w100" style="display: flex;margin-top: 0; margin: 0.3em;flex-direction: column;">
            <h3>הסכמה לסדציה</h3>

            <p>לצורך ביצוע הפעולה הטיפולית/אבחנתית תקבל תכשיר/תרופה שיגרום לסדציה (טשטוש) המביאה לידי שיכוך כאב,הרגעה ו/או הרפיה.</p>
            <p>סדציה גורמת להפחתת הכאב, למצב רגיעה והפחתת חרדה ופחד, כאשר המטופל שומר/ת על הכרה מלאה או יכול/ה להיות מנומנם/ת.</p>
             <p>הוסבר לי תופעות הלוואי הצפויות לאחר סדציה הכוללות- בחילה,הקאה וישנוניות.</p>
             <p>אני מצהיר/ה ומאשר/ת בזאת כי הוסברו לי סיבוכים האפשריים, הכוללים בין היתר, דיכוי נשימה עקב מתן נוזלים ו/או תרופות לווריד.</p>
             <p>במקרים נדירים עלולים להופיע הזיות, תגובה אלרגית,חום,פריחה ובמקרים נדירים מאוד דום לב או תרדמת. תתכן אפשרות של צורך באשפוז להשגחה והמשך טיפול.</p>
             <p>אצל אישה בהריון, יתכן מעבר של חלק מחומרי הסדציה לעובר, ויתכנו,  במקרים נדירים תופעות לוואי וסיבוכים לעובר או להמשך ההריון.</p>
            <p>הוסבר לי שיתכן כשולונות בביצוע הסדציה,המחייב לעיתים מתן טיפולים להבטחת פעילות המערכת החיונית, ועד ביצוע פעולות לצורך הצלת חיים.</p>
            <p>הובהר לי כי במקרה כזה יתכן ולא תתבצע הפעולה המתוכננת.</p>

            <h3>הסכמה לאנדוסקופיה</h3>

            <p>האנדוסקופ הוא צינור גמיש שבתוכו מצויים סיבים אופטיים, דרכם ניתן לראות,ותעלות דרכן ניתן להעביר מכשיריםלצורך לקיחת ביופסיות,כריתת פוליפים,צריבת נקודותדמם,טיפול בדליות והוצאת גוף זר.</p>
            <p>אורכו של האנדוסקופ נע בין 1.20 ל1.80. קוטרו 1 ס"מ, וניתן בעזרתו לבדוק את מערכת העיכול העליונהוהתחתונה. בדרך כלל,לפני הבדיקה, מקבל הנבדק תתרופות הרגעה ו/או אלחוש מקומי, על מנת להפחית את תחושת אי הנוחות שבבדיקה. </p>
            <p>הבדיקה מבוצעת כאשר הנבדק שוכב על צידו השמאלי. כאשר מדובר בבדיקה של דרכי עיכול עליונות  </p>
            <p>  (אזופגוסקופיה, גסטרוסקופיה ) מוחדר האנדוסקופ דרך הפה.</p>
            <p> כאשר מדובר בבדיקה של דרכי עיכול תחתונות (סיגמואידוסקופיה,קולונוסקופיה) מוחדר האנדוסקופ דרך פי הטבעת.</p>
            <p>בהמשך מוחדרים דרכו מכשירים בהתאם לפעולות הנדרשות. משך הבדיקה נע,בדרך כלל, בין 15 דקות לשעה. במשך הבדיקה 'יימת הרגשה של אי נוחות ונפיחות בבטן</p>
            <p>הוסבר לי על קיומן של חלופות אבחנתיות,יתרונן,חסרונן,תופעות הלוואי שלהן והסיבוכים האפשריים.</p>
            <p>אני מצהיר/ה ומאשר/ת בזאת כי הוסברו לי תופעות הלוואי של הטיפול העיקרי לרבות כאב, אי נוחות ותחושבה של נפיחות בבטן.</p>
            <p>כמו כן, הוסברו לי הסיבוכים האפשריים לרבות: דימום או קרע של דופן מערכת העיכול, אשר בחלק מהמקרים יצריכו תיקון ניתוחי.</p>
            <p>בבדיקת דרכי עיכול עליונות עלול להיגרם נזק לשיניים עקב החדרת המכשיר דרך הפה. הסיבוכים האמורים אינם שכיחים.</p>
            <p>אני נותן/ת בזאת את הסכמתי לביצוע הטיפול העיקרי.</p>
            <p>כמו כן, אני מצהיר/ה ומאשר/ת בזאת כי הוסבר לי ואני מבין/ה שקיימת אפשרות שתוך ביצוע הטיפול העיקרי או מיד לאחריו יתברר שיש צורך להרחיב את היקפו,לשנותו או לנקוט בהליכים אחרים או נוספים לצןרך הצלת חיים או למינעת נזק גופני, לרבות פעולות כירוגיות שלא ניתן לצפותם כעת אבוודאות או במלואם, אך משמעותם הובהרה לי.</p>
            <p>לפיכך אני מסכים/ה גם לאותה הרחבה,שנוי אוו ביצוע הליכים אחרים או נוספים,לרבות פעולות כירוגיות שלדעת רופאי המוסד יהיו חיוניים או דרושים במהלך הטיפול העיקרי או מיד לאחריו.</p>
            <p>הסכמתי ניתנת בזאת גם למתן תרופות הרגעה ואלחוש מקומי לאחר שהוסבר לי שהשימוש בתרופות הרגעה עלול לגרום,לעיתים נדירות,להפרעות בנשימה והלהפרעות בפעילות הלב בעיקר אצל חולי לב וחולי מערכת הנשימה, וכן הסיכון האפשרי של תגובה אלרגית בדרגות שונות לחומר המאלחש.</p>
            <p>אני יודע/ת ומסכים/ה לכך שהטיפול העיקרי וכל ההליכים האחרים ייעשו ביד מי שהדבר יוטל עליו,בהתאם לנהלים ולהוראות של המוסד וכי לא הובטח לי שייעשו,כולם או חלקם, בידי אדם מסויים, ובלבד שייעשו באחריות המקובלת במוסד בכפוף לחוק.</p>
            <div>
            <h2 style="display: inline;">הוסבר לי על הצורך בביצוע <strong>{{examsPerformed}} </strong> אבחונית ו/או טיפולית לרבות לקיחת ביופסיה,כריתת פוליפים,צריבת נקודות דמם, טיפול בדליות והוצאת גוף זר. פרט טיפול אחר</h2>
            <span class="t-field t-field--number" style="direction: rtl; display: inline-block;">
                <input class="t-field-text" type="'text" formControlName="otherTreatment"/> 
             </span>
             <h2 style="display: inline-block;">.(להלן: "הטיפול העיקרי")</h2>
            </div>

            
            <div style="display: flex;">
                <p style="margin-top: 0.5em;"> אני מצהיר/ה ומאשר/ת בזאת שקיבלתי הסבר מפורט בעל פה מ: </p>
                <span class="t-field t-field--number" style="direction: rtl;">
                   <input class="t-field-text" type="'text" formControlName="doctor"/> 
                </span>
                 </div>
                <div style="display: flex;justify-content: space-evenly;">
                    <div class="w20" style="display: flex; margin-top: 0.3em;">
                        <span style="margin-left: 0.3em; align-self: center;">יום:</span>
                        <span class="t-field t-field--number" style="direction: rtl;">
                            <p class="t-field-text">{{ gfs.Form.get("CreationTime").value | date: 'EEEE' | translateDay }}</p>
                        </span>
                    </div>
                    <div class="w20" style="display: flex;margin-top: 0.3em;">
                        <span style="margin-right: 1.5em;align-self: center;">תאריך:</span>
                        <span class="t-field t-field--number" style="direction: rtl;">
                            <p class="t-field-text">{{gfs.Form.get("CreationTime").value |date:"dd.MM.yyyy" }}</p>
 
                        </span>
                    </div>
                    <div class="w30" style="display: flex;margin-top: 0.3em;margin-right: 2em;">
                        <span style="margin-right: 1.5em;;align-self: center;">שעה :</span>
                        <span class="t-field t-field--number" style="direction: rtl;">
                            <p class="t-field-text">{{gfs.Form.get("CreationTime").value |date:'HH:mm' }}</p>
 
                        </span>
                    </div>
            </div>
            
            <span><input type="checkbox" formControlName="Guardian"> באם אפוטרופוס</span>
            <div style="display: grid" *ngIf="this.gfs.Form.get('Guardian').value!==true && this.gfs.Form.get('Guardian').value!=1">
                <span>חתימת המטופל/ת:</span>
                <canvas id="canvaspatSign" #canvaspatSign [style.border]="'1px solid black'"  [ngClass]="'can-shadow'" width="300" height="200"   (touchstart)="setPatCanvas()"></canvas>
                <button   style="position: relative;top: -2em;width: fit-content;" (click)="clearSign()">                                            
                    <ng-container>
                        <img src="../../assets/icons/login/reset.png" style='height: 1.5em;width: 1.5em' matTooltip="Clear">
                    </ng-container>
                </button>
 
            </div>
           
           
            <div style="display: flex;flex-direction: row; justify-content: space-around;">
                <div style="display: grid" *ngIf="this.gfs.Form.get('Guardian').value===true || this.gfs.Form.get('Guardian').value==1">
                    <span>חתימת אפוטרופוס (במקרה של פסול דין/קטין/חולה נפש)</span>
                    <canvas id="canvaguardianSign" #canvaguardianSign [style.border]="'1px solid black'"  [ngClass]="'can-shadow'" width="300" height="200"   (touchstart)="setguardianSignCanvas()"></canvas>
                    <button   style="position: relative;top: -2em;width: fit-content;" (click)="clearguardianSignSign()">                                            
                        <ng-container>
                            <img src="../../assets/icons/login/reset.png" style='height: 1.5em;width: 1.5em' matTooltip="Clear">
                        </ng-container>
                    </button>
                    
                </div>
                <div *ngIf="this.gfs.Form.get('Guardian').value===true || this.gfs.Form.get('Guardian').value==1">
                    <span>
                        שם האפוטרופוס:
                    </span>
                    <input class="t-field t-field-text" formControlName="GuardianName" />
                </div>
           </div>
 
           <h2>אני מאשר שהסברתי לחולה/לאפוטרופוס של החולה את כל האמור לעיל בפירוט הדרוש כי הוא/היא חתם על הסכמה בפני לאחר ששוכנעתי כי הבין/נה את כל הסברי במלואם</h2>
           <div style="display: flex;justify-content: space-evenly;margin-bottom: 3%;">
            <div class="w20" style="display: flex; margin-top: 0.3em;">
                <span style="margin-left: 0.3em; align-self: center;">יום:</span>
                <span class="t-field t-field--number" style="direction: rtl;">
                    <p class="t-field-text">{{ gfs.Form.get("CreationTime").value | date: 'EEEE' | translateDay }}</p>
                </span>
            </div>
            <div class="w20" style="display: flex;margin-top: 0.3em;">
                <span style="margin-right: 1.5em;align-self: center;">תאריך:</span>
                <span class="t-field t-field--number" style="direction: rtl;">
                    <p class="t-field-text">{{gfs.Form.get("CreationTime").value |date:"dd.MM.yyyy" }}</p>

                </span>
            </div>
            <div class="w30" style="display: flex;margin-top: 0.3em;margin-right: 2em;">
                <span style="margin-right: 1.5em;;align-self: center;">שעה :</span>
                <span class="t-field t-field--number" style="direction: rtl;">
                    <p class="t-field-text">{{gfs.Form.get("CreationTime").value |date:'HH:mm' }}</p>

                </span>
            </div>
            </div>
           <div style="display: flex;flex-direction: row-reverse; justify-content: right;">
            <span class="t-field t-field--number" style="direction: rtl;">
                <input class="t-field-text" type="'text" formControlName="doctor"/> 
             </span>
             <div style="display: grid">
                <span>חתימת הרופא/ה:</span>
                <canvas id="docSign" #canvasDocSign [style.border]="'1px solid black'"  [ngClass]="'can-shadow'" width="300" height="200"   (touchstart)="setDocCanvas()"></canvas>
                <button   style="position: relative;top: -2em;width: fit-content;" (click)="clearDocSign()">                                            
                    <ng-container>
                        <img src="../../assets/icons/login/reset.png" style='height: 1.5em;width: 1.5em' matTooltip="Clear">
                    </ng-container>
                </button>
 
            </div>

            </div>
        </div>

    </div>
    <div class="m-box" style="direction: rtl; margin: 1em 0; justify-content: space-between;">
        <section class="w100" style="direction: rtl; justify-content: space-evenly; display: flex;">  
            <button class="accept" (click)="saveForm()">Save</button>
            <button class="accept" (click)="saveAndClose()">Save and Close</button>
        </section>
    </div>